import { Drawer, DrawerElement } from '@farol-ds/react'
import {
  attachBrowserBackButtonListener,
  cleanupHistoryState,
} from '@jusbrasil-web/shared-browser-back-button-listener'
import { useGA4Dispatcher } from '@jusbrasil-web/shared-ga4'
import { GA4CustomComponentRenderedEvent } from '@jusbrasil-web/shared-ga4-events'
import { forwardRef, useContext, useState } from 'react'

import { JUSBRASIL_BASE_URL } from '../../constants'
import { TopbarContext } from '../../context'
import { TopbarUserMenuProps } from '../../types'
import { sendUnifiedClickEvent } from '../../utils'
import { JUSBRASIL_NEWS_GA4 } from './ga4'
import { mountItems } from './menu-items/mount'
import { TopbarUserMenuContent } from './topbar-user-menu-content'
import { TopbarUserMenuTrigger } from './topbar-user-menu-trigger'
import { TopbarUserMenuUnlogged } from './topbar-user-menu-unlogged'

export type TopbarUserMenuElement = DrawerElement

export const TopbarUserMenu = forwardRef<TopbarUserMenuElement, TopbarUserMenuProps>(
  function TopbarUserMenu(props, forwardedRef) {
    const { mountMenuItems, overrideMenuItem, ...rest } = props

    const [open, setOpen] = useState<boolean>(false)

    const ctx = useContext(TopbarContext)
    const { user } = ctx
    const { sendGA4Event } = useGA4Dispatcher()

    const handleOpen = (opened: boolean) => {
      setOpen(opened)
      const stateName = 'userMenuModalOpen'

      if (opened) {
        sendUnifiedClickEvent('Menu do usuário', user?.pid)

        const menuCtx = { baseUrl: JUSBRASIL_BASE_URL, userUrl: user?.url || null }
        const defaultItems = mountItems(ctx)
        const resolvedItems = mountMenuItems ? mountMenuItems(defaultItems, menuCtx) : defaultItems
        if (resolvedItems.some((item) => item === 'jusbrasil-news')) {
          sendGA4Event(
            new GA4CustomComponentRenderedEvent({
              componentClass: JUSBRASIL_NEWS_GA4.componentClass,
              componentName: JUSBRASIL_NEWS_GA4.componentName,
            })
          )
        }

        attachBrowserBackButtonListener(stateName, () => {
          setOpen(false)
        })
      } else {
        cleanupHistoryState(stateName)
      }
    }

    return (
      <>
        <Drawer {...rest} ref={forwardedRef} open={open} onOpenChange={handleOpen}>
          <TopbarUserMenuTrigger />
          <TopbarUserMenuContent
            mountMenuItems={mountMenuItems}
            overrideMenuItem={overrideMenuItem}
          />
        </Drawer>
        <TopbarUserMenuUnlogged />
      </>
    )
  }
)
